module.exports = __webpack_public_path__ + "img/settings8.af4e4893.png";